<template>
  <section class="game-hubs-section">
    <div class="game-hubs-section__container">
      <div class="section-header">
        <h2 class="section-header__title">LATEST GAMES</h2>
        <div class="section-header__line"></div>
        <a href="/games/" class="section-header__link">SEE ALL</a>
      </div>

      <div v-if="gameHubs.length > 0" class="hubs-grid">
        <article
          v-for="hub in gameHubs"
          :key="hub.slug"
          class="hub-card"
        >
          <a :href="hub.url" class="hub-card__link">
            <div v-if="hub.image" class="hub-card__image">
              <img :src="hub.image" :alt="hub.title" />
            </div>
            <div class="hub-card__overlay">
              <h3 class="hub-card__title">{{ hub.title }}</h3>
              <div v-if="hub.articleCount" class="hub-card__meta">
                {{ hub.articleCount }} FILES
              </div>
            </div>
          </a>
        </article>
      </div>
      <div v-else class="empty-state">
        <p>NO GAME DATA FOUND.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GameHubsSection',
  computed: {
    gameHubs() {
      const hubs = this.$store.state.gameHubs.gameHubs
      return hubs ? hubs.slice(0, 8) : []
    },
  },
}
</script>

<style lang="scss" scoped>
.game-hubs-section {
  padding: rem(48) 0;
  background: $bg-primary;
}

.game-hubs-section__container {
  max-width: $container-max-width;
  margin: 0 auto;
  padding: 0 rem(24);
}

.section-header {
  display: flex;
  align-items: center;
  gap: rem(24);
  margin-bottom: rem(48);

  &__title {
    font-size: rem(32);
    color: $text-primary;
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 0;
  }

  &__line {
    flex: 1;
    height: 2px;
    background-color: $border-color;
  }

  &__link {
    color: $primary-color;
    font-family: $font-family-heading;
    font-size: rem(16);
    font-weight: 900;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 1px;
    transition: color $transition-speed;

    &:hover {
      color: $text-primary;
    }
  }
}

.hubs-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: rem(24);

  @include pc {
    grid-template-columns: repeat(4, 1fr);
    gap: rem(24);
  }
}

.hub-card {
  position: relative;
  background: $bg-secondary;
  border: 1px solid $border-color;
  height: rem(250);
  overflow: hidden;
  @include brutal-hover;

  @include pc {
    height: rem(220);
  }

  &__link {
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease, filter 0.5s ease;
      filter: grayscale(30%);
    }
  }

  &:hover &__image img {
    transform: scale(1.05);
    filter: grayscale(0%);
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: rem(24);
    z-index: 10;
  }

  &__title {
    font-size: rem(28);
    color: $text-primary;
    margin: 0 0 rem(8) 0;
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    line-height: 1.1;
    letter-spacing: 1px;

    @include pc {
      font-size: rem(22);
      letter-spacing: 0.5px;
    }
  }

  &__meta {
    font-size: rem(14);
    color: $primary-color;
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    letter-spacing: 2px;
  }
}

.empty-state {
  text-align: center;
  padding: rem(64);
  font-family: $font-family-heading;
  font-weight: 900;
  font-size: rem(24);
  color: $text-muted;
  border: 2px dashed $border-color;
  text-transform: uppercase;
}
</style>
